import { faDownload } from '@fortawesome/pro-solid-svg-icons';

import QuickLinkSection from '../QuickLinkSection';
import { QuickLinkSectionItem } from '../QuickLinkSectionItem';

export const SectionResources = () => (
  <QuickLinkSection title="Resources">
    <QuickLinkSectionItem
      href="/docs/master-services-agreement.pdf"
      icon={faDownload}
      title="Master Services Agreement"
    />
    <QuickLinkSectionItem
      href="/docs/control-center-addendum.pdf"
      icon={faDownload}
      title="Control Center Addendum"
    />
  </QuickLinkSection>
);
